import React from 'react';

const SicTablaReporteGrupos = ({ reporteData, fechaDesde, fechaHasta }) => {
    return (
        <div className="reporte-grupos">
            {Object.entries(reporteData).map(([empresa, datosEmpresa], index) => (
                <TablaPrincipal 
                    key={empresa}
                    datosEmpresa={datosEmpresa}
                    fechaDesde={fechaDesde}
                    fechaHasta={fechaHasta}
                    index={index}
                />
            ))}
        </div>
    );
};

// El resto del código (TablaPrincipal, FilaProducto, etc.) se mantiene igual...
// [Aquí va todo el código restante que ya tenías]

// ... (todo el código de los componentes TablaPrincipal, FilaProducto, etc. que ya tenías)

const TablaPrincipal = ({ datosEmpresa, fechaDesde, fechaHasta, index }) => {
    const semanas = obtenerSemanasOrdenadas(datosEmpresa.totales.semanas);
    const mesesEnRango = obtenerMesesEnRango(semanas);
    const headerClass = obtenerClaseEncabezado(index);
    const grupos = Object.keys(datosEmpresa.grupos || {}).sort();

    return (
        <div className="empresa-reporte">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 className="mb-1 text-dark fw-bold">Reporte Consolidado de Productos</h5>
                    <small className="text-muted">
                        Período: {mesesEnRango} {obtenerAñoDeSemanas(semanas)} | 
                        Grupos: {grupos.length} | 
                        Productos: {Object.keys(datosEmpresa.productos).length}
                    </small>
                </div>
                <span className="badge badge-empresa">
                    {semanas.length} Semana{semanas.length !== 1 ? 's' : ''}
                </span>
            </div>
            
            <div className="table-responsive" style={{ maxHeight: '600px', fontSize: '0.75rem' }}>
                <table className="table table-sm table-bordered table-hover mb-2">
                    <thead className="sticky-top">
                        <tr>
                            <th rowSpan="2" className={`align-middle text-center ${headerClass}`} 
                                style={{ minWidth: '200px', maxWidth: '250px' }}>
                                Producto
                            </th>
                            {semanas.map(semana => (
                                <th key={`${semana.numero}-${semana.mes}-${semana.año}`} colSpan="3" 
                                    className={`text-center ${headerClass}`} 
                                    style={{ minWidth: '180px' }}>
                                    <div>S{semana.numero}</div>
                                    <div style={{ fontSize: '0.6rem', opacity: 0.9 }}>
                                        {obtenerNombreMes(semana.mes)} {semana.año}
                                    </div>
                                </th>
                            ))}
                            <th colSpan="3" className={`text-center ${headerClass}`} 
                                style={{ minWidth: '200px' }}>
                                TOTALES
                            </th>
                        </tr>
                        <tr>
                            {semanas.map(semana => (
                                <React.Fragment key={`sub-${semana.numero}-${semana.mes}-${semana.año}`}>
                                    <th className={`text-center table-sub-header`} 
                                        style={{ width: '60px' }}>
                                        P.U. c/Imp
                                    </th>
                                    <th className={`text-center table-sub-header`} 
                                        style={{ width: '50px' }}>
                                        Cant
                                    </th>
                                    <th className={`text-center table-sub-header`} 
                                        style={{ width: '70px' }}>
                                        Monto c/Imp
                                    </th>
                                </React.Fragment>
                            ))}
                            <th className={`text-center table-sub-header`} 
                                style={{ width: '60px' }}>
                                Cant Total
                            </th>
                            <th className={`text-center table-sub-header`} 
                                style={{ width: '70px' }}>
                                Monto Total
                            </th>
                            <th className={`text-center table-sub-header`} 
                                style={{ width: '70px' }}>
                                Costo Prom.
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {grupos.map((nombreGrupo, grupoIndex) => (
                            <React.Fragment key={nombreGrupo}>
                                {/* Fila de encabezado del grupo */}
                                <tr className="table-grupo-header">
                                    <td colSpan={semanas.length * 3 + 4} className="fw-bold text-center" 
                                        style={{ background: obtenerColorGrupo(grupoIndex), color: 'white', fontSize: '0.8rem' }}>
                                        {nombreGrupo} - {Object.keys(datosEmpresa.grupos[nombreGrupo].productos).length} Producto(s)
                                    </td>
                                </tr>
                                
                                {/* Productos del grupo */}
                                {Object.entries(datosEmpresa.grupos[nombreGrupo].productos)
                                    .sort(([productoA], [productoB]) => productoA.localeCompare(productoB))
                                    .map(([producto, datosProducto], prodIndex) => (
                                    <FilaProducto 
                                        key={producto}
                                        producto={producto}
                                        datosProducto={datosProducto}
                                        semanas={semanas}
                                        index={prodIndex}
                                        colorGrupo={obtenerColorGrupo(grupoIndex)}
                                    />
                                ))}
                                
                                {/* Totales del grupo por semana - SIN P.U. */}
                                <FilaTotalesGrupoPorSemana
                                    grupo={datosEmpresa.grupos[nombreGrupo]}
                                    semanas={semanas}
                                    nombreGrupo={nombreGrupo}
                                />
                                
                                {/* Totales del grupo */}
                                <FilaTotalesGrupo 
                                    totales={datosEmpresa.grupos[nombreGrupo].totales}
                                    numSemanas={semanas.length}
                                    cantidadProductos={Object.keys(datosEmpresa.grupos[nombreGrupo].productos).length}
                                    nombreGrupo={nombreGrupo}
                                />
                                
                                {/* Espaciado entre grupos */}
                                {grupoIndex < grupos.length - 1 && (
                                    <tr>
                                        <td colSpan={semanas.length * 3 + 4} style={{ height: '5px', background: '#f8f9fa' }}></td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                        
                        {/* TOTALES POR SEMANA - SIN P.U. */}
                        <FilaTotalesPorSemana 
                            datosEmpresa={datosEmpresa}
                            semanas={semanas}
                        />
                    </tbody>
                    <tfoot>
                        <FilaTotalesGenerales 
                            totales={datosEmpresa.totales}
                            numSemanas={semanas.length}
                            totalGrupos={grupos.length}
                            totalProductos={Object.keys(datosEmpresa.productos).length}
                        />
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

// Fila para cada producto (sin cambios)
const FilaProducto = ({ producto, datosProducto, semanas, index, colorGrupo }) => {
    const cantidadTotal = obtenerNumeroSeguro(datosProducto.totales.cantidadTotal);
    const montoTotal = obtenerNumeroSeguro(datosProducto.totales.montoTotal);
    
    let costoPromedio = 0;
    if (cantidadTotal > 0 && montoTotal > 0) {
        costoPromedio = montoTotal / cantidadTotal;
    }
    
    if (isNaN(costoPromedio)) {
        costoPromedio = 0;
    }

    const rowClass = index % 2 === 0 ? 'table-light' : '';
    
    const nombreMostrar = producto.length > 35 
        ? producto.substring(0, 35) + '...' 
        : producto;

    return (
        <tr className={rowClass}>
            <td style={{ fontSize: '0.7rem', borderLeft: `4px solid ${colorGrupo}` }} title={producto}>
                <div className="fw-bold">{nombreMostrar}</div>
                <small className="text-muted">Código: {datosProducto.codigoEmpresa}</small>
            </td>
            
            {semanas.map(semana => {
                const claveSemana = `S${semana.numero}_${semana.mes}_${semana.año}`;
                const datosSemana = datosProducto.semanas[claveSemana] || {
                    precioUnitario: 0,
                    cantidad: 0,
                    monto: 0,
                    impuesto: 0
                };

                const cantidad = obtenerNumeroSeguro(datosSemana.cantidad);
                const monto = obtenerNumeroSeguro(datosSemana.monto);
                
                // CALCULAR PRECIO UNITARIO CORRECTO: monto / cantidad
                let precioUnitarioConImpuesto = 0;
                if (cantidad > 0 && monto > 0) {
                    precioUnitarioConImpuesto = monto / cantidad;
                }

                return (
                    <React.Fragment key={claveSemana}>
                        <td className="text-end" style={{ fontSize: '0.65rem' }}>
                            {precioUnitarioConImpuesto > 0 ? `₡${formatearNumero(precioUnitarioConImpuesto)}` : '-'}
                        </td>
                        <td className="text-end" style={{ fontSize: '0.65rem' }}>
                            {cantidad !== 0 ? formatearNumero(cantidad) : '-'}
                        </td>
                        <td className="text-end fw-bold" style={{ fontSize: '0.65rem' }}>
                            {monto !== 0 ? `₡${formatearNumero(monto)}` : '-'}
                        </td>
                    </React.Fragment>
                );
            })}
            
            <td className="text-end fw-bold table-active" style={{ fontSize: '0.7rem' }}>
                {formatearNumero(cantidadTotal)}
            </td>
            <td className="text-end fw-bold table-active" style={{ fontSize: '0.7rem' }}>
                ₡{formatearNumero(montoTotal)}
            </td>
            <td className="text-end fw-bold table-active" style={{ fontSize: '0.7rem' }}>
                ₡{formatearNumero(costoPromedio)}
            </td>
        </tr>
    );
};

// Fila de totales por semana para cada grupo - SIN COLUMNA P.U.
const FilaTotalesGrupoPorSemana = ({ grupo, semanas, nombreGrupo }) => {
    return (
        <tr className="table-totals-grupo-semana">
            <td className="fw-bold text-end" style={{ background: '#f8f9fa', fontSize: '0.7rem' }}>
                Total {nombreGrupo} x Semana
            </td>
            
            {semanas.map(semana => {
                const claveSemana = `S${semana.numero}_${semana.mes}_${semana.año}`;
                
                // Calcular totales para esta semana sumando todos los productos del grupo
                let cantidadTotal = 0;
                let montoTotal = 0;
                
                Object.values(grupo.productos || {}).forEach(producto => {
                    const datosSemanaProducto = producto.semanas?.[claveSemana] || {};
                    const cantidad = obtenerNumeroSeguro(datosSemanaProducto.cantidad);
                    const monto = obtenerNumeroSeguro(datosSemanaProducto.monto);
                    
                    cantidadTotal += cantidad;
                    montoTotal += monto;
                });

                return (
                    <React.Fragment key={claveSemana}>
                        {/* CELDA VACÍA donde iba el P.U. */}
                        <td style={{ background: '#f8f9fa' }}></td>
                        <td className="text-end fw-bold" style={{ background: '#f8f9fa', fontSize: '0.65rem' }}>
                            {cantidadTotal > 0 ? formatearNumero(cantidadTotal) : '-'}
                        </td>
                        <td className="text-end fw-bold" style={{ background: '#f8f9fa', fontSize: '0.65rem' }}>
                            {montoTotal > 0 ? `₡${formatearNumero(montoTotal)}` : '-'}
                        </td>
                    </React.Fragment>
                );
            })}
            
            <td colSpan="3" style={{ background: '#f8f9fa' }}></td>
        </tr>
    );
};

// Fila de totales generales por grupo (sin cambios)
const FilaTotalesGrupo = ({ totales, numSemanas, cantidadProductos, nombreGrupo }) => {
    const cantidadTotal = obtenerNumeroSeguro(totales.cantidadTotal);
    const montoTotal = obtenerNumeroSeguro(totales.montoTotal);
    
    let costoPromedio = 0;
    if (cantidadTotal > 0 && montoTotal > 0) {
        costoPromedio = montoTotal / cantidadTotal;
    }
    
    if (isNaN(costoPromedio)) {
        costoPromedio = 0;
    }

    return (
        <tr className="table-totals-grupo">
            <td className="fw-bold">
                TOTAL {nombreGrupo} ({cantidadProductos} producto{cantidadProductos !== 1 ? 's' : ''})
            </td>
            {Array(numSemanas * 3).fill().map((_, i) => (
                <td key={i}></td>
            ))}
            <td className="text-end fw-bold">
                {formatearNumero(cantidadTotal)}
            </td>
            <td className="text-end fw-bold">
                ₡{formatearNumero(montoTotal)}
            </td>
            <td className="text-end fw-bold">
                ₡{formatearNumero(costoPromedio)}
            </td>
        </tr>
    );
};

// Fila de totales por semana consolidados - SIN COLUMNA P.U.
const FilaTotalesPorSemana = ({ datosEmpresa, semanas }) => {
    return (
        <tr className="table-totals-semana">
            <td className="fw-bold text-center" style={{ background: '#e3f2fd' }}>
                TOTALES POR SEMANA
            </td>
            
            {semanas.map(semana => {
                const claveSemana = `S${semana.numero}_${semana.mes}_${semana.año}`;
                const totalSemana = datosEmpresa.totalesPorSemana?.[claveSemana] || {
                    cantidadTotal: 0,
                    montoTotal: 0
                };

                const cantidadTotal = obtenerNumeroSeguro(totalSemana.cantidadTotal);
                const montoTotal = obtenerNumeroSeguro(totalSemana.montoTotal);

                return (
                    <React.Fragment key={claveSemana}>
                        {/* CELDA VACÍA donde iba el P.U. */}
                        <td style={{ background: '#e3f2fd' }}></td>
                        <td className="text-end fw-bold" style={{ background: '#e3f2fd', fontSize: '0.65rem' }}>
                            {cantidadTotal > 0 ? formatearNumero(cantidadTotal) : '-'}
                        </td>
                        <td className="text-end fw-bold" style={{ background: '#e3f2fd', fontSize: '0.65rem' }}>
                            {montoTotal > 0 ? `₡${formatearNumero(montoTotal)}` : '-'}
                        </td>
                    </React.Fragment>
                );
            })}
            
            <td colSpan="3" style={{ background: '#e3f2fd' }}></td>
        </tr>
    );
};

// Fila de totales generales (sin cambios)
const FilaTotalesGenerales = ({ totales, numSemanas, totalGrupos, totalProductos }) => {
    const cantidadTotal = obtenerNumeroSeguro(totales.cantidadTotal);
    const montoTotal = obtenerNumeroSeguro(totales.montoTotal);
    
    let costoPromedio = 0;
    if (cantidadTotal > 0 && montoTotal > 0) {
        costoPromedio = montoTotal / cantidadTotal;
    }
    
    if (isNaN(costoPromedio)) {
        costoPromedio = 0;
    }

    return (
        <tr className="table-totals-generales">
            <td className="fw-bold">
                TOTAL GENERAL ({totalGrupos} grupos, {totalProductos} productos)
            </td>
            {Array(numSemanas * 3).fill().map((_, i) => (
                <td key={i}></td>
            ))}
            <td className="text-end fw-bold">
                {formatearNumero(cantidadTotal)}
            </td>
            <td className="text-end fw-bold">
                ₡{formatearNumero(montoTotal)}
            </td>
            <td className="text-end fw-bold">
                ₡{formatearNumero(costoPromedio)}
            </td>
        </tr>
    );
};

// Funciones auxiliares (sin cambios)
const obtenerNumeroSeguro = (valor) => {
    if (valor === null || valor === undefined || valor === '') return 0;
    const numero = Number(valor);
    return isNaN(numero) ? 0 : numero;
};

const formatearNumero = (numero) => {
    const numeroSeguro = obtenerNumeroSeguro(numero);
    return new Intl.NumberFormat('es-CR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(numeroSeguro);
};

const obtenerColorGrupo = (index) => {
    const colores = ['#5b8cff', '#28a745', '#ffc107', '#dc3545', '#6f42c1', '#fd7e14'];
    return colores[index % colores.length];
};

const obtenerSemanasOrdenadas = (semanasData) => {
    const semanas = Object.values(semanasData)
        .sort((a, b) => {
            if (a.año !== b.año) return a.año - b.año;
            if (a.mes !== b.mes) return a.mes - b.mes;
            return a.numero - b.numero;
        });
    return semanas.filter(semana => !isNaN(semana.numero));
};

const obtenerNombreMes = (mes) => {
    const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
    const mesSeguro = obtenerNumeroSeguro(mes);
    return meses[mesSeguro] || 'DES';
};

const obtenerMesesEnRango = (semanas) => {
    if (semanas.length === 0) return '';
    const mesesUnicos = [...new Set(semanas.map(s => s.mes))];
    const mesesNombres = mesesUnicos.map(obtenerNombreMes);
    if (mesesNombres.length === 1) return mesesNombres[0];
    return `${mesesNombres[0]} - ${mesesNombres[mesesNombres.length - 1]}`;
};

const obtenerAñoDeSemanas = (semanas) => {
    if (semanas.length === 0) return new Date().getFullYear();
    const añosUnicos = [...new Set(semanas.map(s => s.año))];
    if (añosUnicos.length === 1) return añosUnicos[0];
    return `${añosUnicos[0]} - ${añosUnicos[añosUnicos.length - 1]}`;
};

const obtenerClaseEncabezado = (index) => {
    const clases = ['table-main-header', 'table-primary-header', 'table-info-header', 'table-success-header'];
    return clases[index % clases.length];
};

export default SicTablaReporteGrupos;